{
  "Featured news": "Utvalda nyheter",
  "post-load-error": "Ett fel uppstod. <0>Klicka här</0> för att försöka igen.",
  "Create post": "Posta inlägg",
  "My team": "Mitt team",
  "General": "Start",
  "Something went wrong": "Ett fel uppstod",
  "Channels": "Diskussionskanaler",
  "Team Channels": "Teamkanaler",
  "Select a team channel": "Välj ett team",
  "No action available": "Inga actions möjliga ",
  "New channel": "Skapa ny kanal",
  "Channel path": "Kanalens sökväg",
  "Channel alias": "Kanalens namn",
  "Channel description": "Beskrivning",
  "Add channel": "Spara",
  "Cancel": "Avbryt",
  "Update channel": "Redigera",
  "Could not update section:": "Kunde inte uppdatera sektion:",
  "Ask a question": "Skapa gemensam reflektion",
  "Write a post": "Skapa inlägg",
  "Create new post": "Skapa nytt inlägg",
  "Edit": "Redigera",
  "Post": "Skapa",
  "New reflection": "Ny reflektion",
  "No posts yet.": "Det finns inga poster.",
  "No reflections yet.": "Det finns inga reflektioner.",
  "Show more": "Visa mer",
  "Invalid time format: YYYY-MM-DD HH:mm": "Ogiltigt datumformat: YYYY-MM-DD HH:mm",
  "[deleted]": "[borttaget]",
  "Publishing: {{date}}": "Publiceras: {{date}}",
  "Text (required)": "Text (obligatorisk)",
  "Title": "Rubrik (obligatorisk)",
  "Update": "Uppdatera",
  "Copy code": "Kopiera kod",
  "Delete": "Ta bort",
  "Are you sure you want to delete this post?": "Är du säker på att du vill ta bort inlägget?",
  "Are you sure you want to delete this reflection?": "Är du säker på att du vill ta bort reflektionen?",
  "post-error": "Något blev fel. Försök igen.",
  "Write an answer...": "Skriv en kommentar.",
  "Sticky": "Låt stå!",
  "Un-sticky": "Ångra låt stå",
  "Make sticky": "Låt stå!",
  "admin": "admin",
  "member": "medlem",
  "moderator": "moderator",
  "Write a comment": "Skriv en kommentar",
  "Reply": "Svara",
  "Comment": "Kommentar",
  "Comment_plural": "Kommentarer",
  "Send notification": "Ska skicka e-post",
  "notification-verb": "reagerade på",
  "notification-verb_LIKE": "gillade",
  "notification-verb_REPLY": "kommenterade på",
  "notification-post": "<0>{{name}}</0> {{verb}} ditt inlägg <1>{{title}}</1> i kanalen <2>{{channel}}</2>",
  "notification-post_product": "<0>{{name}}</0> {{verb}} ditt inlägg <1>{{title}}</1> i kanalen <2>{{channel}}</2> i {{productTitle}}",
  "notification-reflection": "<0>{{name}}</0> {{verb}} din reflektion <1>{{title}}</1> i {{productTitle}}",
  "Are you sure that you want to clear all notifications?": "Är du säker på att du vill rensa alla notiser?",
  "notification-other": "+ 1 till",
  "notification-other_plural": "+{{count}} andra",
  "Preview": "Förhandsvisa"
}
